module.exports = __webpack_public_path__ + "assets_app/img/key-8.3b645b0a.svg";